export default "__VITE_ASSET__rC6mdS$e__"